import { ReactNode } from 'react';
import { NotificationSeverity } from '../../storage/types';
import {
    AlertSuccess,
    AlertInfo,
    AlertWarning,
    AlertError,
} from '.';
import { NotificationMessageProps } from '../../routes/dashboard/types';

const NotificationMessage = (props: NotificationMessageProps) => {
    const {
        id,
        message,
        severity,
        canClose,
        onClose,
        role,
        ariaLive,
    } = props;

    switch (severity) {
        case NotificationSeverity.Success:
            return (
                <AlertSuccess
                    id={id || 'notif-success-message'}
                    role={role}
                    aria-live={ariaLive}
                    canClose={canClose}
                    onClose={onClose}
                >
                    <div className='d-flex justify-content-center justify-content-md-start mb-3 mb-md-0'>
                        <div className='bgCircle mb-3 mb-sm-0 me-3'>
                            <i className='icon-tick' aria-hidden='true' />
                        </div>
                    </div>
                    <div>
                        {message as ReactNode}
                    </div>
                </AlertSuccess>
            );
        case NotificationSeverity.Information:
            return (
                <AlertInfo
                    id={id || 'notif-info-message'}
                    role={role}
                    aria-live={ariaLive}
                    canClose={canClose}
                    onClose={onClose}
                >
                    <div className='d-flex justify-content-center justify-content-md-start mb-3 mb-md-0'>
                        <div className='bgCircle mb-3 mb-sm-0 me-3'>
                            <i className='icon-info' aria-hidden='true' />
                        </div>
                    </div>
                    <div>
                        {message as ReactNode}
                    </div>
                </AlertInfo>
            );
        case NotificationSeverity.Warning:
            return (
                <AlertWarning
                    id={id || 'notif-warning-message'}
                    role={role}
                    aria-live={ariaLive}
                    canClose={canClose}
                    onClose={onClose}
                >
                    <div className='d-flex justify-content-center justify-content-md-start mb-3 mb-md-0'>
                        <div className='bgCircle mb-3 mb-sm-0 me-3'>
                            <i className='icon-warning' aria-hidden='true' />
                        </div>
                    </div>
                    <div>
                        {message as ReactNode}
                    </div>
                </AlertWarning>
            );
        case NotificationSeverity.Error:
            return (
                <AlertError
                    id={id || 'notif-error-message'}
                    role={role}
                    aria-live={ariaLive}
                    canClose={canClose}
                    onClose={onClose}
                >
                    <div className='d-flex justify-content-center justify-content-md-start mb-3 mb-md-0'>
                        <div className='bgCircle mb-3 mb-sm-0 me-3'>
                            <i className='icon-warning' aria-hidden='true' />
                        </div>
                    </div>
                    <div>
                        {message as ReactNode}
                    </div>
                </AlertError>
            );
        default:
            return (
                <AlertError
                    id={id || 'notif-error-message'}
                    role={role}
                    aria-live={ariaLive}
                    canClose={canClose}
                    onClose={onClose}
                >
                    <div className='d-flex justify-content-center justify-content-md-start mb-3 mb-md-0'>
                        <div className='bgCircle mb-3 mb-sm-0 me-3'>
                            <i className='icon-warning' aria-hidden='true' />
                        </div>
                    </div>
                    <div>
                        {message as ReactNode}
                    </div>
                </AlertError>
            );
    }
};

export default NotificationMessage;
